<div
  class="note-box"
  [ngClass]="['note-box--' + type, customClass || '']"
  [ngStyle]="customStyle"
>
  <i [class]="defaultIcon + ' note-box__icon'"></i>
  <div class="note-box__content">
    <span *ngIf="text" [innerHTML]="text"></span>
    <ng-content></ng-content>
  </div>
</div>
